module.exports = __webpack_public_path__ + "img/SD-fig2.fff777e9.svg";